module.exports = __webpack_public_path__ + "img/fountain-pen.png";